import SpecificTime from './specific-time';

import options from './time-period.component';

const Component = {
    selector: 'dtTimePeriod',
    options
};

export {
    Component,
    SpecificTime,
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/index.js